import {ResultStatusType} from "../../domain/verification/ResultStatusType";
import {VerifyService} from "../../service/VerifyService";

export const VerifyExtractionViewModel = (verificationId: string | undefined) => {

    const verifyExtractionResult = async (): Promise<ResultStatusType> => {
        if (verificationId) {
            return await VerifyService.getInstance().getExtractionResult(verificationId)
        }
        return ResultStatusType.PENDING
    }

    return {
        verifyExtractionResult
    }

}